import maplibregl from "maplibre-gl";
import { facadeMidpoint } from "../../config/facades";

// ── Nummern-Labels der Fassaden ("1", "2", …) ────────────────────────
// Verbindet die Zeile in der Fassaden-Tabelle mit der roten Linie auf der
// Karte. Bewusst als HTML-Marker und NICHT als MapLibre-Symbol-Layer:
// Text-Layer brauchen eine `glyphs`-URL im Style, und unser Style
// (MapInit.js) hat nur die Esri-Kacheln — ein Symbol-Layer mit text-field
// würde dort schlicht nichts zeichnen. Marker kommen ohne Schrift-Server aus.
//
// Die Marker hängen am Map-Objekt (map.__facadeLabels), damit mehrere
// Karteninstanzen sich nicht in die Quere kommen.
// ─────────────────────────────────────────────────────────────────────

function makeLabelElement(number) {
  const el = document.createElement("div");
  el.textContent = String(number);
  el.style.cssText = [
    "display:flex",
    "align-items:center",
    "justify-content:center",
    "width:20px",
    "height:20px",
    "border-radius:10px",
    "background:#FF0000",           // gleiche Farbe wie die Fassadenlinie
    "color:#ffffff",
    "font:600 12px/1 system-ui, sans-serif",
    "border:1.5px solid #ffffff",
    "box-shadow:0 1px 3px rgba(0,0,0,0.4)",
    "pointer-events:none",          // darf das Weiterzeichnen nicht abfangen
  ].join(";");
  return el;
}

export function renderFacadeLabels(map, buildingPolylines) {
  if (!map) return;

  const existing = map.__facadeLabels || [];
  const lines = Array.isArray(buildingPolylines) ? buildingPolylines : [];

  // Marker sind billig und die Anzahl ist einstellig — komplett neu
  // setzen ist einfacher (und weniger fehleranfällig) als zu diffen.
  existing.forEach((m) => m.remove());

  map.__facadeLabels = lines
    .map((line, i) => {
      const mid = facadeMidpoint(line);
      if (!mid) return null;
      return new maplibregl.Marker({ element: makeLabelElement(i + 1) })
        .setLngLat(mid)
        .addTo(map);
    })
    .filter(Boolean);
}

export function clearFacadeLabels(map) {
  if (!map) return;
  (map.__facadeLabels || []).forEach((m) => m.remove());
  map.__facadeLabels = [];
}
